export function buildLandingStructuredData({ siteUrl, email, name, slogan, logoPath, services, faqs }) {
    const organizationId = `${siteUrl}/#organization`;

    return {
        '@context': 'https://schema.org',
        '@graph': [
            {
                '@type': 'ProfessionalService',
                '@id': organizationId,
                name,
                slogan,
                url: `${siteUrl}/`,
                logo: `${siteUrl}${logoPath}`,
                image: `${siteUrl}${logoPath}`,
                email,
                areaServed: { '@type': 'Country', name: 'Colombia' },
                knowsLanguage: 'es',
                hasOfferCatalog: {
                    '@type': 'OfferCatalog',
                    name: 'Servicios para medios y marcas',
                    itemListElement: services.map(service => ({
                        '@type': 'Offer',
                        itemOffered: {
                            '@type': 'Service',
                            name: service.title,
                            description: `${service.summary} ${service.items.join(', ')}.`,
                            provider: { '@id': organizationId },
                        },
                    })),
                },
            },
            {
                '@type': 'WebSite',
                '@id': `${siteUrl}/#website`,
                url: `${siteUrl}/`,
                name,
                inLanguage: 'es-CO',
                publisher: { '@id': organizationId },
            },
            {
                '@type': 'FAQPage',
                '@id': `${siteUrl}/#faq`,
                mainEntity: faqs.map(faq => ({
                    '@type': 'Question',
                    name: faq.question,
                    acceptedAnswer: { '@type': 'Answer', text: faq.answer },
                })),
            },
        ],
    };
}
